import { CompletedSeriesScreenSkeleton } from './completed-series-screen-skeleton'
import React from 'react'
import { PageContainer } from 'src/component/page-container/page-container'
import { BackArrow } from 'src/component/programmes/programme-back-arrow'
import { Grid } from 'src/component/ui/grid/grid'
import { PageTitle } from 'src/component/ui/page-title'
import { SeriesCard } from 'src/component/ui/series-card'
import { useMyCompletedProgrammes } from 'src/hook/use-programmes'
import { toasterUtil } from 'src/util/toaster-util'

export const CompletedSeriesScreen = (): React.ReactElement => {
  const {
    data: hustlerSeries = [],
    isLoading,
    isError,
  } = useMyCompletedProgrammes({
    onError: () => {
      toasterUtil.error('We are having difficulties loading your completed series, please try again.')
    },
  })

  const completedSeries = hustlerSeries?.map((hp) => hp.programme) || []

  return (
    <PageContainer>
      <div className="py-6 md:py-[82px]">
        <div className="mb-10">
          <BackArrow />
        </div>
        <div className="mb-10">
          <PageTitle>Completed Series</PageTitle>
        </div>
        {isLoading || isError ? (
          <CompletedSeriesScreenSkeleton />
        ) : (
          <Grid
            items={completedSeries}
            keyExtractor={(p) => p.id}
            renderItem={(programme) => <SeriesCard.Default series={programme} />}
          />
        )}
      </div>
    </PageContainer>
  )
}
